var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999807 6.82932C1.18717 7.01557 1.44062 7.12012 1.70481 7.12012C1.96899 7.12012 2.22244 7.01557 2.40981 6.82932L5.99981 3.28932L9.53981 6.82932C9.72717 7.01558 9.98062 7.12012 10.2448 7.12012C10.509 7.12012 10.7624 7.01558 10.9498 6.82932C11.0435 6.73636 11.1179 6.62576 11.1687 6.5039C11.2195 6.38204 11.2456 6.25134 11.2456 6.11932C11.2456 5.98731 11.2195 5.85661 11.1687 5.73475C11.1179 5.61289 11.0435 5.50229 10.9498 5.40932L6.70981 1.16932C6.61684 1.0756 6.50624 1.0012 6.38438 0.950433C6.26253 0.899664 6.13182 0.873526 5.99981 0.873526C5.8678 0.873526 5.73709 0.899664 5.61523 0.950433C5.49337 1.0012 5.38277 1.0756 5.28981 1.16932L0.999808 5.40932C0.906079 5.50229 0.831685 5.61289 0.780916 5.73475C0.730147 5.85661 0.704008 5.98731 0.704008 6.11932C0.704008 6.25134 0.730147 6.38204 0.780916 6.5039C0.831685 6.62576 0.906079 6.73636 0.999807 6.82932Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowV2);
export default __webpack_public_path__ + "static/media/arrowV2.2f951665.svg";
export { ForwardRef as ReactComponent };